enum PromotionBindType {
  SALEPAGE = 1,
  TAG = 2,
  CATEGORY = 3,
}

export default PromotionBindType;
